import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.IAMUrl,
  addToken: false,
});

const axiosInstanceWithToken = getAxiosInstance({
  baseUrl: apiConfig.IAMUrl,
});

const login = async ({ username, password }) => {
  if (!username || !password) {
    throw new Error('Please check your username and password');
  }

  try {
    // commented by shyam vir for new login API for PetroHub for testing perpose, will remove old API call once new API is confirmed working fine
    const response = await axiosInstance.post(`/token/loginWithPassword?key=${apiConfig.APIKey}`, {
    // const response = await axiosInstance.post('/api/v1/Auth/Authenticate/WithGroup/Petrohub', {
      Username: username,
      Password: password,
      LoginType: 'LDAP',
      Provider: 'default',
      ApplicationID: apiConfig.ApplicationID
    });

    return {
      accessToken: response.data.AccessToken,
      userData: response.data.UserData,
    };
  } catch (e) {
    throw new Error('Please check your username and password');
  }
};
const loginPetroHub = async ({ username, password }) => {
  if (!username || !password) {
    throw new Error('Please check your username and password');
  }

  try {
    const response = await axiosInstance.post(`/api/v1/Auth/Authenticate/WithGroup/Petrohub?key=${apiConfig.APIKeyPetrohub}`, {
      Username: username,
      Password: password,
      LoginType: 'LDAP',
      Provider: 'default',
      ApplicationID: apiConfig.ApplicationID,
    });

    return {
      accessToken: response.data.AccessToken,
      refreshToken: response.data.RefToken,
      userData: response.data.UserData,
    };
  } catch (e) {
    throw new Error('Please check your username and password');
  }
};

export const refreshToken = async (token) => {
  try {
    const res = await axiosInstance.post('/token/RefreshToken', {
      Token: token,
    });

    return {
      accessToken: res.data.AccessToken,
    };
  } catch (error) {
    throw new Error('Refresh error');
  }
};

const me = async (token) => {
  try {
    const res = await axiosInstance.post('/token/GetUserDataByToken', {
    // const res = await axiosInstance.post('/api/v1/auth/GetUserDataByToken/Petrohub', { // for petrohub
      Token: token,
    });

    return {
      User: res.data.User,
      UserObjects: res.data.UserObjects,
      RoleClaims: res.data.RoleClaims,
    };
  } catch (error) {
    throw new Error('GetUserData error');
  }
};
const mePetroHub = async (token) => {
  try {
    const res = await axiosInstance.post('/api/v1/auth/GetUserDataByToken/Petrohub', {
      Token: token,
    });

    return {
      User: res.data.User,
      UserObjects: res.data.UserObjects,
      RoleClaims: res.data.RoleClaims,
      // for petrohub, as permissions are not coming in response, using dummy permissions data for now. Will remove it once we get permissions data from API response.
      Permissions: res.data.Permissions,
      // for petrohub, as user to roles are not coming in response, using dummy user to roles data for now. Will remove it once we get user to roles data from API response.
      UserToRoles: res.data.UserToRoles,
      CustomPermissions: res.data.CustomPermissions,

    };
  } catch (error) {
    throw new Error('GetUserData error');
  }
};

const forgotPassword = async ({ username }) => {
  if (!username) {
    throw new Error('Please check your username');
  }

  try {
    const response = await axiosInstance.post('/api/v1/Auth/ForgotPassword', {
      ApplicationID: apiConfig.ApplicationID,
      Username: username,
      Provider: 'default',
    });

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return false;
};

const passwordRecovery = async (_data) => {
  try {
    // const res = await axiosInstanceWithToken.post(`/api/v1/Auth/UserID/${_data.UserID}/PasswordRecovery`, {
    const res = await axiosInstanceWithToken.post(`/api/v1/Auth/UserID/${_data.UserID}/PasswordRecoveryABV`, {
      ApplicationID: apiConfig.ApplicationID,
      Provider: 'default'
    });

    return res.data;
  } catch (error) {
    throw new Error('Password Recovery error');
  }
};

const adjustToken = async ({ token, claims }) => {
  try {
    const res = await axiosInstance.post('/token/AdjustToken', {
      Token: token,
      UpdateClaims: claims
    });

    return {
      accessToken: res.data.AccessToken,
      refreshToken: res.data.RefToken,
    };
  } catch (error) {
    throw new Error('Refresh error');
  }
};

const AuthApi = {
  login,
  loginPetroHub,
  me,
  mePetroHub,
  refreshToken,
  forgotPassword,
  passwordRecovery,
  adjustToken,
};

export default AuthApi;
